import { getTeamMembers } from "../../services/wisdomServices/managerService";

/**
 * Checks whether an employee belongs to a manager's team.
 *
 * @param {number} managerId
 * @param {number} employeeId
 * @returns {Promise<boolean>}
 */
export const validateTeamMemberAccess = async (
  managerId,
  employeeId
) => {
  const pageSize = 100;
  let pageNumber = 1;
  let totalPages = 1;
  const teamMembers = [];

  do {
    const response = await getTeamMembers(
      managerId,
      false,
      null,
      pageNumber,
      pageSize
    );

    if (Array.isArray(response?.data)) {
      teamMembers.push(...response.data);
    }

    totalPages = Math.max(
      Number(response?.pagination?.totalPages) || 1,
      1
    );

    pageNumber += 1;
  } while (pageNumber <= totalPages);

  return teamMembers.some(
    (member) => Number(member.id) === employeeId
  );
};